export { default, Circle, G, Line, Path, Rect, Text } from 'react-native-svg';
